import { render, staticRenderFns } from "./MeasuresTab.vue?vue&type=template&id=1d7e8ce6&scoped=true&"
import script from "./MeasuresTab.vue?vue&type=script&lang=js&"
export * from "./MeasuresTab.vue?vue&type=script&lang=js&"
import style0 from "./MeasuresTab.vue?vue&type=style&index=0&id=1d7e8ce6&scoped=true&lang=css&"
import style1 from "./MeasuresTab.vue?vue&type=style&index=1&id=1d7e8ce6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e8ce6",
  null
  
)

export default component.exports